// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { t } from "../lib/i18n.js";

/**
 * The Granite wordmark (packages/ui/brand): dark letters on light themes, white on dark ones.
 * Both images are in the page; styles.css shows the one that fits the theme.
 */
export function Logo({ className = "h-7" }: { className?: string }) {
  return (
    <>
      <img
        src="/logo-dark.svg"
        alt={t("app.name")}
        className={`gr-logo-light w-auto ${className}`}
      />
      <img
        src="/logo-white.svg"
        alt={t("app.name")}
        className={`gr-logo-dark w-auto ${className}`}
      />
    </>
  );
}
